import React, { FC } from 'react'
import { Redirect, Route } from 'react-router-dom'
import AuthenticationContext from '../Authentication/AppContext'
import AuthService from '../Authentication/AuthService'

type ProtectedRouteProps = {
  path: string
  permissions: string[]
  Component: any
  exact?: boolean
  props?: any
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ path, permissions, exact = false, Component, props }) => {
  const { userPermissions } = React.useContext(AuthenticationContext)

  if (!AuthService.hasPermission(userPermissions, permissions)) {
    return <Redirect to='/accessdenied' />
  }

  return <Route exact={exact} path={path} render={() => <Component props={props} />} />
}

export default ProtectedRoute
